import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, OnChanges, SimpleChanges } from '@angular/core';
import { ShowHideDirective as FlexLayoutShowHideDirective } from '@angular/flex-layout';

const inputs = [
  'flLayoutShow',
  'flLayoutShow.mobile',
  'flLayoutShow.tablet',
  'flLayoutShow.desktop-small',
  'flLayoutShow.desktop-large',
  'flLayoutShow.desktop-xlarge',
  'flLayoutShow.desktop-xxlarge',
  'flLayoutHide',
  'flLayoutHide.mobile',
  'flLayoutHide.tablet',
  'flLayoutHide.desktop-small',
  'flLayoutHide.desktop-large',
  'flLayoutHide.desktop-xlarge',
  'flLayoutHide.desktop-xxlarge',
];

@Directive({
  selector: `
    [flLayoutShow],
    [flLayoutShow.mobile],
    [flLayoutShow.tablet],
    [flLayoutShow.desktop-small],
    [flLayoutShow.desktop-large],
    [flLayoutShow.desktop-xlarge],
    [flLayoutShow.desktop-xxlarge],
    [flLayoutHide],
    [flLayoutHide.mobile],
    [flLayoutHide.tablet],
    [flLayoutHide.desktop-small],
    [flLayoutHide.desktop-large],
    [flLayoutHide.desktop-xlarge],
    [flLayoutHide.desktop-xxlarge],
  `,
  inputs,
})
export class LayoutShowHideDirective extends FlexLayoutShowHideDirective
  implements OnChanges {
  protected inputs = inputs;

  // Manual override of @angular/flex-layout's onChanges hook is necessary because
  // we use a custom directive `flLayoutHide` instead of their `fxHide`
  ngOnChanges(changes: SimpleChanges) {
    Object.keys(changes).forEach(key => {
      if (this.inputs.indexOf(key) !== -1) {
        const inputKey = key.split('.');
        const bp = inputKey.slice(1).join('.');
        const inputValue = changes[key].currentValue;
        let shouldShow =
          inputValue !== ''
            ? inputValue !== 0
              ? coerceBooleanProperty(inputValue)
              : false
            : true;
        if (inputKey[0] === 'flLayoutHide') {
          shouldShow = !shouldShow;
        }
        this.setValue(shouldShow, bp);
      }
    });
  }
}
